module.exports = __webpack_public_path__ + "img/computer10.e3dea5b6.gif";